import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuoteAddressDTO } from '../../interfaces/quote-address';

@Component({
  selector: 'b2c-address-confirmation',
  templateUrl: 'b2c-address-confirmation.component.html',
  styleUrls: ['b2c-address-confirmation.component.scss', 'b2c-widget.component.scss'],
})
export class B2cAddressConfirmationComponent implements OnInit {
  addressForm: FormGroup;

  private _address: QuoteAddressDTO;
  @Input('address')
  public set address(value: QuoteAddressDTO) {
    this._address = value;
    this.addressForm.patchValue(value);
  }

  public get address(): QuoteAddressDTO {
    return this._address;
  }

  private _isPickup: boolean;
  @Input('isPickup')
  public set isPickup(value: boolean) {
    this._isPickup = value;
    this.locationName = value ? 'Collection' : 'Delivery';
  }

  public get isPickup(): boolean {
    return this._isPickup;
  }

  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output('addressChange') addressEmitter: EventEmitter<any> = new EventEmitter<any>();

  locationName: string;

  constructor(private formBuilder: FormBuilder) {
    this.addressForm = this.formBuilder.group({
      businessName: ['', Validators.required],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      addressLine3: [''],
      city: [''],
      postcode: ['', Validators.required],
      latitude: [],
      longitude: [],
    });
  }

  ngOnInit() {}

  addressChange($event: any) {
    this.addressForm.patchValue({
      latitude: $event.lat,
      longitude: $event.lng,
    });

    this.addressEmitter.emit({
      ...this.addressForm.value,
      country: this.address.country,
      primaryAddress: this.getPrimaryAddress(),
    });
  }

  getPrimaryAddress() {
    const addressFormValue = this.addressForm.getRawValue();
    const parts = [
      addressFormValue.businessName,
      addressFormValue.addressLine1,
      addressFormValue.addressLine2,
      addressFormValue.addressLine3,
      addressFormValue.city,
      addressFormValue.postcode,
    ];
    return parts.filter((x) => x && x != '').join(', ');
  }

  get af() {
    return this.addressForm.value;
  }

  confirmAddress() {
    this.addressEmitter.emit({
      ...this.addressForm.value,
      country: this.address.country,
      primaryAddress: this.getPrimaryAddress(),
    });
    this.visibleChange.emit(false);
  }
}
